import React from 'react';
import { Navigate } from 'react-router-dom';
import { isCurrentAuthUserAdmin } from '../lib/authSession';

interface RequireAdminProps {
  children: React.ReactNode;
}

/** Keep internal operational routes out of the participant experience. */
const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  if (!isCurrentAuthUserAdmin()) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
